document.addEventListener("DOMContentLoaded", function () {
  const scrollBox = document.getElementById("scroll-box");

  if (!scrollBox) {
    return; // Exit if scroll-box does not exist
  }

  let scrollTimeout;

  function handleScroll() {
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight;

    let scrollThreshold = getScrollThreshold();
    let scrollPercentage = calculateScrollPercentage(pageHeight, scrollThreshold);

    const maxScrollLeft = scrollBox.scrollWidth - scrollBox.clientWidth;
    scrollBox.scrollLeft = maxScrollLeft * scrollPercentage * 25;

    updateGradient(scrollBox, maxScrollLeft);
  }

  function getScrollThreshold() {
    return window.innerWidth > 1400 ? 0.26 : 0.3;
  }

  function calculateScrollPercentage(pageHeight, scrollThreshold) {
    let scrollPercentage = (window.scrollY / pageHeight - scrollThreshold) / (1 - scrollThreshold);
    return Math.max(0, Math.min(1, scrollPercentage));
  }

  function updateGradient(scrollBox, maxScrollLeft) {
    const effectScroll = document.querySelector(".effect-scroll");
    const scrollBoxPercentage = scrollBox.scrollLeft / maxScrollLeft;
    const startPercent = 100 * (1 - scrollBoxPercentage);
    const endPercent = startPercent;

    effectScroll.style.background = `linear-gradient(90deg, rgba(224, 215, 213, 1) ${startPercent}%, rgba(0,0,0,1) ${endPercent}%)`;
  }

  function applySmoothScroll() {
    if (window.innerWidth < 600) {
      scrollBox.style.scrollBehavior = "smooth";
    }
  }

  function applyAutoScroll() {
    scrollBox.style.scrollBehavior = "auto";
  }

  document.addEventListener("click", function (event) {
    if (scrollBox.contains(event.target)) {
      applySmoothScroll();
    }
  });

  scrollBox.addEventListener("touchstart", applySmoothScroll);

  window.addEventListener("scroll", function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(applyAutoScroll, 100);
  });

  // Attach the scroll event only if the scroll box exists
  document.addEventListener("scroll", handleScroll);
});
